import { Component, OnInit } from '@angular/core';
import { BlogService, BlogPost } from '@services/blog.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlogEditComponent } from '../blog-edit/blog-edit.component';
import { BlogCategoryManageComponent } from '../blog-category-manage/blog-category-manage.component';
import { BlogAiGenerateComponent } from '../blog-ai-generate/blog-ai-generate.component';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',

})
export class BlogListComponent implements OnInit {
  posts: BlogPost[] = [];
  loading = false;
  currentPage = 1;
  pageSize = 10;
  totalCount = 0;
  totalPages = 0;
  searchTerm = '';

  constructor(
    private blogService: BlogService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.loadPosts();
  }

  loadPosts(): void {
    this.loading = true;
    this.blogService.getPosts(undefined, undefined, undefined, this.currentPage, this.pageSize, this.searchTerm)
      .subscribe({
        next: (response) => {
          this.posts = response.data;
          this.totalCount = response.totalCount;
          this.totalPages = response.totalPages;
          this.loading = false;
        },
        error: (error) => {
          console.error('Blog yükleme hatası:', error);
          this.toastr.error('Blog yazıları yüklenirken hata oluştu', 'Hata');
          this.loading = false;
        }
      });
  }

  openCategoryManageModal(): void {
    const modalRef = this.modalService.open(BlogCategoryManageComponent, { size: 'xl', backdrop: 'static' });
    
    modalRef.result.then(
      () => { this.loadPosts(); },
      () => {}
    );
  }

  openAiGenerateModal(): void {
    const modalRef = this.modalService.open(BlogAiGenerateComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then(
      (result) => { if (result) { this.loadPosts(); } },
      () => {}
    );
  }

  openCreateModal(): void {
    const modalRef = this.modalService.open(BlogEditComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.isEditMode = false;

    modalRef.result.then(
      (result) => { 
        if (result) { 
          this.loadPosts(); 
        } 
      },
      () => {}
    );
  }

  openEditModal(post: BlogPost): void {
    const modalRef = this.modalService.open(BlogEditComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.isEditMode = true;
    modalRef.componentInstance.postData = post;

    modalRef.result.then(
      (result) => { 
        if (result) { 
          this.loadPosts(); 
        } 
      },
      () => {}
    );
  }

  deletePost(post: BlogPost): void {
    if (confirm(`"${post.title}" başlıklı blog yazısını silmek istediğinize emin misiniz?`)) {
      this.blogService.deletePost(post.id!).subscribe({
        next: () => {
          this.toastr.success('Blog yazısı başarıyla silindi', 'Başarılı');
          this.loadPosts();
        },
        error: (error) => {
          console.error('Silme hatası:', error);
          this.toastr.error('Blog yazısı silinirken hata oluştu', 'Hata');
        }
      });
    }
  }

  onSearch(): void {
    this.currentPage = 1;
    this.loadPosts();
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadPosts();
  }

  getStatusBadge(post: BlogPost): string {
    return post.isPublished ? 'badge-success' : 'badge-warning';
  }

  getStatusText(post: BlogPost): string {
    return post.isPublished ? 'Yayında' : 'Taslak';
  }
}
